import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";

export default function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setLoading(true);
    setErr(false);
    api.get(`/pages/${slug}`)
      .then((r) => setPage(r.data))
      .catch(() => setErr(true))
      .finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [slug]);

  if (loading) return <div className="max-w-3xl mx-auto px-4 py-20 animate-pulse"><div className="h-10 bg-zinc-100 rounded w-2/3" /><div className="h-4 bg-zinc-100 rounded w-1/2 mt-3" /><div className="h-3 bg-zinc-100 rounded mt-8" /><div className="h-3 bg-zinc-100 rounded mt-2 w-5/6" /></div>;
  if (err || !page) return (
    <div className="max-w-3xl mx-auto px-4 py-20 text-center" data-testid="page-not-found">
      <h1 className="font-devanagari font-black text-3xl">पेज नहीं मिला</h1>
      <Link to="/" className="mt-4 inline-block text-[#E30613] font-outfit font-bold bodh-link">← Home पर वापस</Link>
    </div>
  );

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid={`page-${slug}`}>
      <div className="font-outfit font-black uppercase tracking-widest text-xs bodh-text-gradient">Bodh Networks</div>
      <h1 className="mt-2 font-devanagari font-black text-4xl sm:text-5xl text-zinc-900">{page.title}</h1>
      {page.subtitle && <p className="mt-2 font-hind text-zinc-500">{page.subtitle}</p>}
      <div className="mt-8 font-devanagari leading-relaxed text-zinc-700 space-y-4">
        {(page.content || "").split("\n").filter(Boolean).map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    </div>
  );
}
